import React, {useEffect, useState} from 'react';
import {useProjectState} from "../../context/project/ProjectIndex";
import {Badge, Input} from "reactstrap";
import {useAuthState} from "../../context/auth/AuthIndex";
import {UserAccess} from "../../services/api/UserAccess";
import {apiErrorRaised} from "../../context/api_error/ApiErrorActions";
import {useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import DeleteUserAccessButton from "./Delete/DeleteUserAccessButton";

const UserItem = ({user, setDeletedUserAccess}) => {
  const apiErrorDispatch = useApiErrorDispatch()
  const projectState = useProjectState()
  const authState = useAuthState()
  const [userAccess, setUserAccess] = useState(user)

  const handleChange = (e) => {
    let role = e.target.value
    UserAccess.put(projectState.companyId, userAccess.id, {role: role}).then((r) => {
      if (r?.status < 400) {
        setUserAccess({...userAccess, role: role})
      } else {
        apiErrorRaised(apiErrorDispatch, r?.response)
      }
    })
  }

  useEffect(() => {
    setUserAccess(formatUserData(user))
  }, [user])

  // Helper function to get appropriate badge color based on status
  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'locked':
        return 'danger';
      case 'disabled':
        return 'warning';
      case 'deleted':
        return 'dark';
      case 'needs_confirmation':
        return 'info';
      case 'invited':
        return 'primary';
      default:
        return 'secondary';
    }
  };

  // Format date or show placeholder if null
  const formatUserData = (user) => {
    if (user.last_login === null) {
      user = {
        ...user,
        last_login: 'Never',
      }
    } else {
      let date = new Date(user.last_login);
      user = {
        ...user,
        last_login: date.toLocaleString(),
      }
    }
    if (user.last_access === null) {
      user = {
        ...user,
        last_access: 'Never',
      }
    } else {
      let date = new Date(user.last_access);
      user = {
        ...user,
        last_access: date.toLocaleString(),
      }
    }
    return user
  };

  return (
    <>
      <tr>
        <td>
          {userAccess.name}
        </td>
        <td>
          {userAccess.email}
        </td>
        <td>
          {
            authState.user.role === 'admin' || ((projectState.role === 'owner' || projectState.role === 'admin') && userAccess.role !== 'owner') ?
              <Input
                placeholder="Role"
                className={'form-control'}
                type="select"
                name="role"
                value={userAccess.role}
                onChange={handleChange}
              >
                {authState.user.role === 'admin' ? <option value={'owner'}>Owner</option> : <></>}
                <option value={'admin'}>Admin</option>
                <option value={'collaborator'}>Collaborator</option>
                <option value={'viewer'}>Viewer</option>
              </Input>
              : userAccess.role
          }
        </td>
        <td>
          <Badge color={getStatusBadgeColor(userAccess.status)} pill className={'badge-lg'}>
            {userAccess.status ? userAccess.status.charAt(0).toUpperCase() + userAccess.status.slice(1) : 'Unknown'}
          </Badge>
        </td>
        <td>
          {userAccess.last_login}
        </td>
        <td>
          {userAccess.last_access}
        </td>
        <td className={''}>
          <DeleteUserAccessButton
            userAccess={userAccess}
            setDeletedUserAccess={setDeletedUserAccess}
          />
        </td>
      </tr>
    </>
  )
}

export default UserItem;
